import * as React from "react";
import { forwardRef } from "react";
const PlantPotIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 51 50",
  "data-category": "sources",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M22.6936 18.7167s-3.1875 5.4583-7.8125 4.6875C5.5061 21.8417 7.0686 9.34166 3.9436 4.65416c3.02694-1.23742 6.3038-1.74092 9.5626-1.46935 3.2588.27156 6.407 1.31049 9.1874 3.03185 4.6813 3.125 4.6813 7.81254 0 12.50004m10.2542 4.5791s2.2146 3.7875 5.4271 3.2563c6.5104-1.0854 5.4166-9.7667 7.5958-13.0229-2.1025-.8587-4.3783-1.208-6.6416-1.0194s-4.4499.9099-6.3813 2.1048c-3.2542 2.1708-3.2542 5.4271 0 8.6812"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#114A7B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M16.4436 12.4667s9.375 4.6875 10.9375 20.3125c3.125-9.375 7.8125-12.5 7.8125-12.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M33.9125 48.4042H20.85c-.3602 0-.7094-.1243-.9884-.3521s-.4708-.545-.5428-.8979l-2.5-12.5c-.0464-.2271-.0416-.4616.0138-.6866.0555-.2249.1603-.4348.3069-.6143.1466-.1794.3312-.3241.5406-.4234s.4382-.1508.6699-.1507h18.0625c.2319-.0004.461.0509.6706.1501.2096.0991.3946.2437.5414.4232s.2518.3895.3074.6146c.0556.2252.0603.4599.014.6871l-2.5 12.5c-.0725.3531-.2647.6703-.5441.8981-.2794.2277-.6288.352-.9893.3519"
}));
const ForwardRef = forwardRef(PlantPotIcon);
ForwardRef.category = "sources";
export default ForwardRef;
export { ForwardRef as PlantPotIcon };